import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeMark } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'mark';

export const bikeMarkSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeMark(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeMark }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeMark } = bikeMarkSlice.actions;

export const mark = bikeMarkSlice.reducer;
